// removed by extract-text-webpack-plugin
module.exports = {"home":"home__1j6dU","logo":"logo__2GJyu","formField":"formField__1WYXh"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/style.scss
// module id = Lglr
// module chunks = 1